module.exports = __webpack_public_path__ + "static/media/preview.87faaee7.png";